module.exports = __webpack_public_path__ + "028e7a5e290fcf093423ba49da0201d6.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-300.woff2
// module id = 168
// module chunks = 1